/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'glasses': {
    width: 80,
    height: 80,
    viewBox: '0 0 80 80',
    data: `<defs><clipPath id="svgicon_glasses_a"><path pid="0" d="M0 0h80v80H0z"/></clipPath></defs><g clip-path="url(#svgicon_glasses_a)"><path pid="1" d="M.7 38.067h63S73.081 36.074 78.019 58M79.5 38.067h-63S7.116 36.074 2.179 58m31.147-19.435a16.414 16.414 0 11-32.826 0 16.414 16.414 0 1132.826 0zm46.174 0a16.414 16.414 0 11-32.826 0 16.414 16.414 0 1132.826 0z" _fill="none" _stroke="#000"/></g>`
  }
})
/* tslint:enable */
